<template>
  <div
    class="text-[13px] leading-snug whitespace-pre-wrap break-words"
    :class="
      isSent
        ? 'text-[var(--p-primary-0)] dark:text-[var(--p-primary-0)]'
        : 'text-[var(--p-surface-950)] dark:text-[var(--p-surface-50)]'
    "
  >
    <FormattedText :text="text" />
  </div>
</template>

<script setup lang="ts">
import FormattedText from '../../atoms/text/FormattedText.vue'

interface Props {
  text: string
  isSent: boolean
}

defineProps<Props>()
</script>
